import React from 'react';
import { Chip } from "@mui/material";
export const ReviewDataChip = (props) => {
    const { dataText } = props;
    return (React.createElement(Chip, { style: { background: '#00000014', color: '#2E7D32' }, label: dataText, size: 'small' }));
};
